(function () {
    "use strict";

    angular.module("sempraWebapp").factory("ByBoxrViewModel", byBoxViewModelFactory);

    /** @ngInject */
    function byBoxViewModelFactory() {
        function byBoxrViewModel() {}

        byBoxrViewModel.prototype.createChartData = function (data) {
            data.regionCurrency = this.createData(data.regionCurrency, 'MONEY');
            data.tokens = this.createData(data.tokens, 'PIECES_TITLE');
            return data;
        };

        byBoxrViewModel.prototype.createBasicData = function() {
            return {
                groupNames: [],
                groupTotal: [],
                groupsData: [],
                isChartVisible: false
            }
        }

        byBoxrViewModel.prototype.createData = function(data, title) {
            if(data) {
                data.isChartVisible = true;
                data.title = title;
                data.groupsData.map(function(item){
                    switch (true) {
                        case item.groupValue.includes('ONLINE'):
                            return item.groupValue = 'R2W';
                        case item.groupValue.includes('TOKEN'):
                            return item.groupValue = 'METAL TOKEN';
                        case item.groupValue.includes('R2W_'):
                            return item.groupValue = 'LOCAL';
                        default:
                            return item.groupValue
                    }
                });
                data.groupsData = data.groupsData;
            } else {
                data = this.createBasicData();
            }
            return data;
        }

        return byBoxrViewModel;
    }
})();
